import React from 'react'
import PropTypes from 'prop-types'
import styles from './Label.module.scss'

const Label = ({ id, htmlFor, label, className, value }) => {
    const isEmpty = value || value === undefined;
    const isNoticePeriodLabel = id === "noticePeriod";
    return (
        <label
            className={`${styles.label} ${className ? className : ''} ${isEmpty ? styles.float : ''} ${isNoticePeriodLabel ? styles.noticePeriodLabel : ''}`}
            htmlFor={htmlFor}
        >
            {label}
        </label>
    )
}

Label.propTypes = {
    htmlFor: PropTypes.string,
    label: PropTypes.string,
}

export { Label }
